import { useTranslations } from 'next-intl';

const brands = ['Vogue', 'Wired', 'Substack', 'Penguin', 'Notion'];

export const Section9 = () => {
  const t = useTranslations();
  return (
    <section className={styles.section}>
      <div className={styles.wrap}>
        <div className={styles.label}>{t('pages.home.section9.lovedBy')}</div>
        <div className={styles.marks}>
          {brands.map((brand) => (
            <b key={brand} className={styles.mark}>
              {brand}
            </b>
          ))}
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: 'marketing-dark:bg-mf-navy pt-[30px] pb-[14px] text-center',
  wrap: 'max-w-[1200px] mx-auto px-6 lg:px-10',
  label:
    'mb-6 text-sm font-medium text-mf-gray-500 marketing-dark:text-white/50',
  marks:
    'flex flex-wrap items-center justify-center gap-7 opacity-[0.62] sm:gap-12',
  mark: 'text-lg font-extrabold tracking-[-0.02em] text-mf-gray-600 marketing-dark:text-white/85 sm:text-[22px]',
};
